<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col sm="12">
          <b-card header-class="redmfu">
            <div slot="header" v-if="student.thaistudent==1">
              <strong>ยืนยันการติดต่อขอรับปริญญาบัตร</strong>
              <div style="float:right;"
              >
                <b-badge pill variant="warning" class="font-sm text-dark p-2 pr-3 pl-3">Session Timeout :
                  {{ this.$store.state.timeExp }}
                </b-badge>
              </div>
            </div>
            <div slot="header" v-if="student.thaistudent==0">
              <strong>The way to obtain Certificate</strong>
              <div style="float:right;"
              >
                <b-badge pill variant="warning" class="font-sm text-dark p-2 pr-3 pl-3">Session Timeout :
                  {{ this.$store.state.timeExp }}
                </b-badge>
              </div>
            </div>
            <b-form-group label-cols-sm="1" label label-align-sm="right" label-for="nested-street">
              <div>
              </div>

              <b-form-radio-group v-model="selected_post"
                                  value-field="BYTECODE"
                                  text-field="BYTEDES"
                                  :options="items"
                                  stacked
                                  name="selected_post"
              ></b-form-radio-group>
              <div v-if="student.thaistudent==1">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp3. จัดส่งทางไปรษณีย์ โดยให้จัดส่งแบบ
                (โปรดเลือก)
              </div>
              <div v-if="student.thaistudent==0">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp3. By post<br>
                &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                -Domestic
              </div>
              <b-form-group
                label-cols-sm="1"
                label
                label-align-sm="right"
                label-for="nested-street"
              >
                <b-form-radio-group v-model="selected_post"
                                    value-field="BYTECODE"
                                    text-field="BYTEDES"
                                    :options="items1"
                                    stacked
                                    name="selected_post1"
                >
                  <!--                  {{ selected_post }}-->
                </b-form-radio-group>
              </b-form-group>
              <div v-if="student.thaistudent==0">
                &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                -Overseas
              </div>
              <b-form-group
                label-cols-sm="1"
                label
                label-align-sm="right"
                label-for="nested-street"
              >
                <b-form-radio-group
                  v-if="student.thaistudent==0"
                  v-model="selected_post"
                  value-field="BYTECODE"
                  text-field="BYTEDES"
                  :options="items2"
                  stacked
                  name="selected_post2"
                ></b-form-radio-group>
              </b-form-group>
              <div v-if="selected_post=='12' ">
                <label class="mr-sm-2" v-if="student.thaistudent==1">ระบุชื่อ-นามสกุลผู้รับมอบ</label>
                <label class="mr-sm-2" v-if="student.thaistudent==0">Authorized person name</label>
                <b-form-input
                  id="current_authorized"
                  type="text"
                  autocomplete="current_authorized"
                  v-model="current_authorized"
                  placeholder="Authorized person name..."
                ></b-form-input>
              </div>
              <!-- select: {{ selected_post }}  -->
            </b-form-group>

            <div v-if="selected_post=='11' || selected_post=='12'" align="center">
              <font color="red">แสดงหนังสือยืนยันการขอรับปริญญาบัตร พร้อมบัตรประจำตัวนักศึกษาหรือบัตรประจำตัวประชาชน
                <br>หรือหนังสือเดินทาง ต่อเจ้าหน้าที่เพื่อติดต่อขอรับปริญญาบัตร
                <br>ได้ที่ส่วนทะเบียนและประมวลผล ตั้งแต่วันที่ 28 กุมภาพันธ์ พ.ศ. 2565 เวลา 14.30 น. เป็นต้นไป
                <br>สอบถามข้อมูลเกี่ยวกับการจัดส่งปริญญาเบอร์ติดต่อ 053 916433/ 053- 916546 /053-916547


                <br><br>Please show a confirmation letter for obtaining a degree certificate
                <br>with student ID card or passport to the staff for contacting to obtain a degree certificate
                <br>at the registrar division after February 28, 2022 at 2:30 p.m. onwards.
                <br>For more information about a degree certificate delivery, contact number 053-916433 / 053-916546 / 053-916547.


              </font>
            </div>
            <div v-if="selected_post=='21' || selected_post=='22' || selected_post=='31'" align="center">
              <font color="red">ส่วนทะเบียนและประมวลผล จะดำเนินการจัดส่งให้ทางไปรษณีย์
                <br>หลังเสร็จพิธีพระราชทานปริญญาบัตร ภายใน 3 วันทำการ
                <br>
                <br>The Registrar Division will send the degree certificate by post,
                <br>after the commencement ceremony is
                finished within 3 working days.</font>
            </div>

          </b-card>
          <b-card v-if="(selected_post ==11 || selected_post==12)  " header-class="redmfu">
            <div slot="header" v-if="student.thaistudent==1 ">
              <strong>ข้อมูลการติดต่อ</strong>
            </div>
            <div slot="header" v-if="student.thaistudent==0">
              <strong>Personal Data</strong>
            </div>

            <b-row>
              <b-col sm="6">
                <b-form-group label="โทรศัพท์มือถือ(ปัจจุบัน)" :label-cols="4" :horizontal="true"
                              v-if="student.thaistudent==1">
                  <b-form-input
                    id="current_tel"
                    type="text"
                    autocomplete="current_tel"
                    v-model="current_tel"
                  >{{ current_tel }}
                  </b-form-input>
                </b-form-group>
                <b-form-group label="Mobile" :label-cols="4" :horizontal="true" v-else>
                  <b-form-input
                    id="current_tel"
                    type="text"
                    autocomplete="current_tel"
                    v-model="current_tel"
                  >{{ current_tel }}
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="โทรศัพท์บ้าน" :label-cols="2" :horizontal="true" v-if="student.thaistudent==1">
                  <b-form-input
                    id="current_tel_home"
                    type="text"
                    autocomplete="current_tel_home"
                    v-model="current_tel_home"
                  >{{ current_tel_home }}
                  </b-form-input>
                </b-form-group>
                <b-form-group label="Home Phone" :label-cols="2" :horizontal="true" v-else>
                  <b-form-input
                    id="current_tel_home"
                    type="text"
                    autocomplete="current_tel_home"
                    v-model="current_tel_home"
                  >{{ current_tel_home }}
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="Fax" :label-cols="4" :horizontal="true">
                  <b-form-input
                    id="current_fax"
                    type="text"
                    autocomplete="current_fax"
                    v-model="current_fax"
                  >{{ current_fax }}
                  </b-form-input>
                </b-form-group>

              </b-col>
              <b-col sm="6">
                <b-form-group label="Email" :label-cols="2" :horizontal="true">
                  <b-form-input
                    id="current_email"
                    type="text"
                    autocomplete="current_email"
                    v-model="current_email"
                  >{{ current_email }}
                  </b-form-input>
                </b-form-group>

              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="Facebook" :label-cols="4" :horizontal="true">
                  <b-form-input
                    id="current_fb"
                    type="text"
                    autocomplete="current_fb"
                    v-model="current_fb"
                  >{{ current_fb }}
                  </b-form-input>
                </b-form-group>

              </b-col>
            </b-row>


          </b-card>

          <b-card v-if="selected_post ==21 || selected_post==22" header-class="redmfu">
            <div slot="header" v-if="student.thaistudent==1">
              <strong>ที่อยู่ในการจัดส่ง</strong>
            </div>
            <div slot="header" v-if="student.thaistudent==0">
              <strong>Address</strong>
            </div>


            <b-row>
              <b-col sm="6">
                <b-form-group label="ชื่อ" :label-cols="4" :horizontal="true" v-if="student.thaistudent==1">
                  <b-form-input
                    id="current_name"
                    type="text"
                    autocomplete="current_name"
                    v-model="current_name"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="Name" :label-cols="4" :horizontal="true" v-else>
                  <b-form-input
                    id="current_name"
                    type="text"
                    autocomplete="current_name"
                    v-model="current_name"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="นามสกุล" :label-cols="2" :horizontal="true" v-if="student.thaistudent==1">
                  <b-form-input
                    id="current_surname"
                    type="text"
                    autocomplete="current_surname"
                    v-model="current_surname"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="Surname" :label-cols="2" :horizontal="true" v-else>
                  <b-form-input
                    id="current_surname"
                    type="text"
                    autocomplete="current_surname"
                    v-model="current_surname"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="จังหวัด" :label-cols="4" :horizontal="true" v-if="student.thaistudent==1">
                  <b-form-select
                    value-field="PROVINCE_ID"
                    text-field="PROVINCENAME"
                    size="md"
                    :plain="true"
                    :options="provinceItems"
                    v-model="select_province"
                    v-on:change="selectProvinceOnchange"
                  ></b-form-select>
                </b-form-group>
                <b-form-group label="Province" :label-cols="4" :horizontal="true" v-else>
                  <b-form-select
                    value-field="PROVINCE_ID"
                    text-field="PROVINCENAME"
                    size="md"
                    :plain="true"
                    :options="provinceItems"
                    v-model="select_province"
                    v-on:change="selectProvinceOnchange"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="อำเภอ" :label-cols="2" :horizontal="true" v-if="student.thaistudent==1">
                  <b-form-select
                    value-field="DISTRICTID"
                    text-field="DISTRICTNAME"
                    class="mb-3"
                    :plain="true"
                    :options="districtItems"
                    v-model="select_district"
                    v-on:change="selectDistrictOnchange"
                  ></b-form-select>
                </b-form-group>
                <b-form-group label="District" :label-cols="2" :horizontal="true" v-else>
                  <b-form-select
                    value-field="DISTRICTID"
                    text-field="DISTRICTNAME"
                    class="mb-3"
                    :plain="true"
                    :options="districtItems"
                    v-model="select_district"
                    v-on:change="selectDistrictOnchange"
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="ตำบล" :label-cols="4" :horizontal="true" v-if="student.thaistudent==1">
                  <b-form-select
                    value-field="SUB_DISTRICTID"
                    text-field="SUB_DISTRICTNAME"
                    size="md"
                    :plain="true"
                    :options="subdistrictItems"
                    v-model="select_subdistrict"
                    v-on:change="selectSubDistrictOnchange"
                  ></b-form-select>
                </b-form-group>
                <b-form-group label="Subdistrict" :label-cols="4" :horizontal="true" v-else>
                  <b-form-select
                    value-field="SUB_DISTRICTID"
                    text-field="SUB_DISTRICTNAME"
                    size="md"
                    :plain="true"
                    :options="subdistrictItems"
                    v-model="select_subdistrict"
                    v-on:change="selectSubDistrictOnchange"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="รหัสไปรษณีย์" :label-cols="2" :horizontal="true" v-if="student.thaistudent==1">
                  <b-form-input
                    id="current_zipcode"
                    type="text"
                    autocomplete="current_zipcode"
                    v-model="current_zipcode"
                  ></b-form-input>
                  <!--                  readonly-->
                </b-form-group>
                <b-form-group label="Postcode" :label-cols="2" :horizontal="true" v-else>
                  <b-form-input
                    id="current_zipcode"
                    type="text"
                    autocomplete="current_zipcode"
                    v-model="current_zipcode"
                  ></b-form-input>
                  <!--                  readonly-->
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="บ้านเลขที่" :label-cols="4" :horizontal="true" v-if="student.thaistudent==1">
                  <b-form-input
                    id="current_add"
                    type="text"
                    autocomplete="current_add"
                    v-model="current_add"
                    :state="validation_no"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="validation_no">
                    Your Number must be 3-50 characters long.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validation_no">
                    Looks Good.
                  </b-form-valid-feedback>
                </b-form-group>
                <b-form-group label="Address number" :label-cols="4" :horizontal="true" v-else>
                  <b-form-input
                    id="current_add"
                    type="text"
                    autocomplete="current_add"
                    v-model="current_add"
                    :state="validation_no"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="validation_no">
                    Your Number must be 3-50 characters long.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validation_no">
                    Looks Good.
                  </b-form-valid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="หมู่" :label-cols="2" :horizontal="true" v-if="student.thaistudent==1">
                  <b-form-input
                    id="current_moo"
                    type="text"
                    autocomplete="current_moo"
                    v-model="current_moo"
                    :state="validation_moo"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="validation_moo">
                    Your Number must be 1-50 characters long.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validation_moo">
                    Looks Good.
                  </b-form-valid-feedback>
                </b-form-group>
                <b-form-group label="Moo" :label-cols="2" :horizontal="true" v-else>
                  <b-form-input
                    id="current_moo"
                    type="text"
                    autocomplete="current_moo"
                    v-model="current_moo"
                    :state="validation_moo"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="validation_moo">
                    Your Number must be 1-50 characters long.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validation_moo">
                    Looks Good.
                  </b-form-valid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="หมู่บ้าน" :label-cols="4" :horizontal="true" v-if="student.thaistudent==1">
                  <b-form-input
                    id="current_village"
                    type="text"
                    autocomplete="current_village"
                    v-model="current_village"
                    :state="validation_village"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="validation_village">
                    Your Number must be 3-50 characters long.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validation_village">
                    Looks Good.
                  </b-form-valid-feedback>
                </b-form-group>
                <b-form-group label="Village" :label-cols="4" :horizontal="true" v-else>
                  <b-form-input
                    id="current_village"
                    type="text"
                    autocomplete="current_village"
                    v-model="current_village"
                    :state="validation_village"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="validation_village">
                    Your Number must be 3-50 characters long.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validation_village">
                    Looks Good.
                  </b-form-valid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="อาคาร/ตึก" :label-cols="2" :horizontal="true" v-if="student.thaistudent==1">
                  <b-form-input
                    id="current_building"
                    type="text"
                    autocomplete="current_building"
                    v-model="current_building"
                    :state="validation_build"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="validation_build">
                    Your Number must be 1-50 characters long.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validation_build">
                    Looks Good.
                  </b-form-valid-feedback>
                </b-form-group>
                <b-form-group label="Building" :label-cols="2" :horizontal="true" v-else>
                  <b-form-input
                    id="current_building"
                    type="text"
                    autocomplete="current_building"
                    v-model="current_building"
                    :state="validation_build"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="validation_build">
                    Your Soi must be 1-50 characters long.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validation_build">
                    Looks Good.
                  </b-form-valid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="ซอย" :label-cols="4" :horizontal="true" v-if="student.thaistudent==1">
                  <b-form-input
                    id="current_lane"
                    type="text"
                    autocomplete="current_lane"
                    v-model="current_lane"
                    :state="validation_soi"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="validation_soi">
                    Your Soi must be 1-50 characters long.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validation_soi">
                    Looks Good.
                  </b-form-valid-feedback>
                </b-form-group>
                <b-form-group label="Soi" :label-cols="4" :horizontal="true" v-else>
                  <b-form-input
                    id="current_lane"
                    type="text"
                    autocomplete="current_lane"
                    v-model="current_lane"
                    :state="validation_soi"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="validation_soi">
                    Your Soi must be 1-50 characters long.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validation_soi">
                    Looks Good.
                  </b-form-valid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="ถนน" :label-cols="2" :horizontal="true" v-if="student.thaistudent==1">
                  <b-form-input
                    id="current_road"
                    type="text"
                    autocomplete="current_road"
                    v-model="current_road"
                    :state="validation_road"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="validation_road">
                    Your Road must be 1-50 characters long.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validation_road">
                    Looks Good.
                  </b-form-valid-feedback>
                </b-form-group>
                <b-form-group label="Road" :label-cols="2" :horizontal="true" v-else>
                  <b-form-input
                    id="current_road"
                    type="text"
                    autocomplete="current_road"
                    v-model="current_road"
                    :state="validation_road"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="validation_road">
                    Your Road must be 1-50 characters long.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validation_road">
                    Looks Good.
                  </b-form-valid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="โทรศัพท์มือถือ(ปัจจุบัน)" :label-cols="4" :horizontal="true"
                              v-if="student.thaistudent==1">
                  <b-form-input
                    id="current_tel"
                    type="text"
                    autocomplete="current_tel"
                    v-model="current_tel"
                  >{{ current_tel }}
                  </b-form-input>
                </b-form-group>
                <b-form-group label="Mobile" :label-cols="4" :horizontal="true" v-else>
                  <b-form-input
                    id="current_tel"
                    type="text"
                    autocomplete="current_tel"
                    v-model="current_tel"
                  >{{ current_tel }}
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="โทรศัพท์บ้าน" :label-cols="2" :horizontal="true" v-if="student.thaistudent==1">
                  <b-form-input
                    id="current_tel_home"
                    type="text"
                    autocomplete="current_tel_home"
                    v-model="current_tel_home"
                  >{{ current_tel_home }}
                  </b-form-input>
                </b-form-group>
                <b-form-group label="Home Phone" :label-cols="2" :horizontal="true" v-else>
                  <b-form-input
                    id="current_tel_home"
                    type="text"
                    autocomplete="current_tel_home"
                    v-model="current_tel_home"
                  >{{ current_tel_home }}
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="Fax" :label-cols="4" :horizontal="true">
                  <b-form-input
                    id="current_fax"
                    type="text"
                    autocomplete="current_fax"
                    v-model="current_fax"
                  >{{ current_fax }}
                  </b-form-input>
                </b-form-group>

              </b-col>
              <b-col sm="6">
                <b-form-group label="Email" :label-cols="2" :horizontal="true">
                  <b-form-input
                    id="current_email"
                    type="text"
                    autocomplete="current_email"
                    v-model="current_email"
                  >{{ current_email }}
                  </b-form-input>
                </b-form-group>

              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="Facebook" :label-cols="4" :horizontal="true">
                  <b-form-input
                    id="current_fb"
                    type="text"
                    autocomplete="current_fb"
                    v-model="current_fb"
                  >{{ current_fb }}
                  </b-form-input>
                </b-form-group>

              </b-col>
            </b-row>
          </b-card>
          <b-card v-if="student.thaistudent==0 && selected_post==31" header-bg-variant=primary>
            <div slot="header" v-if="student.thaistudent==1">
              <strong>ที่อยู่ในการจัดส่ง</strong>
            </div>
            <div slot="header" v-if="student.thaistudent==0">
              <strong>Address</strong>
            </div>
            <b-row>
              <b-col sm="6">
                <b-form-group label="Country" :label-cols="4" :horizontal="true">
                  <!-- <b-form-select
                      id="select_country"
                      value-field="COUNTRYID"
                      text-field="COUNTRYNAME"
                      v-model="select_country"
                      :plain="true"
                      :options="countryItems"
                      v-on:change="selectCountryOnchange"
                      return-object
                  ></b-form-select> -->
                  <v-select
                    label="COUNTRYNAME"
                    :options="countryItems"
                    v-model="select_country1"
                    @input="selectCountryOnchange"
                  ></v-select>
                  <!-- <div  >{{ select_country1 }}</div> -->
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="6">
                <b-form-group label="Name" :label-cols="4" :horizontal="true">
                  <b-form-input
                    id="current_name"
                    type="text"
                    autocomplete="current_name"
                    v-model="current_name"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="Surname" :label-cols="2" :horizontal="true">
                  <b-form-input
                    id="current_surname"
                    type="text"
                    autocomplete="current_surname"
                    v-model="current_surname"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Adress" :label-cols="2" :horizontal="true">
                  <b-form-input
                    id="current_add"
                    type="text"
                    autocomplete="current_add"
                    v-model="current_add"
                  >{{ current_tel }}
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="Mobile" :label-cols="4" :horizontal="true">
                  <b-form-input
                    id="current_tel"
                    type="text"
                    autocomplete="current_tel"
                    v-model="current_tel"
                    placeholder="xx-xxxx-xxxx"
                  >{{ current_tel }}
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="โทรศัพท์บ้าน" :label-cols="2" :horizontal="true" v-if="student.thaistudent==1">
                  <b-form-input
                    id="current_tel_home"
                    type="text"
                    autocomplete="current_tel_home"
                    v-model="current_tel_home"
                  >{{ current_tel_home }}
                  </b-form-input>
                </b-form-group>
                <b-form-group label="Home Phone" :label-cols="2" :horizontal="true" v-else>
                  <b-form-input
                    id="current_tel_home"
                    type="text"
                    autocomplete="current_tel_home"
                    v-model="current_tel_home"
                  >{{ current_tel_home }}
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="Fax" :label-cols="4" :horizontal="true">
                  <b-form-input
                    id="current_fax"
                    type="text"
                    autocomplete="current_fax"
                    v-model="current_fax"
                  >{{ current_fax }}
                  </b-form-input>
                </b-form-group>

              </b-col>
              <b-col sm="6">
                <b-form-group label="Email" :label-cols="2" :horizontal="true">
                  <b-form-input
                    id="current_email"
                    type="text"
                    autocomplete="current_email"
                    v-model="current_email"
                  >{{ current_email }}
                  </b-form-input>
                </b-form-group>

              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="Facebook" :label-cols="4" :horizontal="true">
                  <b-form-input
                    id="current_fb"
                    type="text"
                    autocomplete="current_fb"
                    v-model="current_fb"
                  >{{ current_fb }}
                  </b-form-input>
                </b-form-group>

              </b-col>

            </b-row>

          </b-card>
        </b-col>
      </b-row>

      <div slot="footer" class="text-center">
        <b-button type="submit" size="md" class="mr-2" variant="primary" @click="onSubmit">
          <i class="fa fa-dot-circle-o"></i> Submit
        </b-button>

        <b-button type="reset" size="md" class="mr-2" variant="danger">
          <i class="fa fa-ban"></i> Reset
        </b-button>
      </div>

      <b-row>
        <b-col lg="6"></b-col>
      </b-row>
    </div>
    <b-modal v-if="student.thaistudent==1"
             title="คุณกรอกข้อมูลไม่ครบถ้วน"
             class="modal-danger"
             v-model="dangerModal"
             @ok="dangerModal = false"
             ok-variant="danger"
    >{{ current_erorrtxt }}
    </b-modal>
    <b-modal v-if="student.thaistudent==0"
             title="You didn’t fill your information completely"
             class="modal-danger"
             v-model="dangerModal"
             @ok="dangerModal = false"
             ok-variant="danger"
    >{{ current_erorrtxt }}
    </b-modal>
  </div>
</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {YimoVueEditor},
  name: "CreateGeneral",
  data() {
    return {
      student: {},
      std_id: "",
      sex: "",

      thai_student: "",
      /*
      studentCode: "",
       prefixName: "",
       studentName: "",
       studentSurname: "",
       studentNameEng: "",
       studentSurnameEng: "",
       prefixNameEng: "",
       levelGroupNameEng: "",
       facultyName: "",
       facultyNameEng: "",
       departmentName: "",
       departmentNameEng: "", */
      numEror: 0,
      current_erorrtxt: "",
      selected_post: "",
      selected_post1: "",
      selected_post2: "",

      other_txt: "",

      dangerModal: false,
      items: [],
      items1: [],
      items2: [],
      actionUpdate: true,
      levelid: "",
      q1: "",
      q2: "",
      q3: "",
      q4: "",
      select_country: "",
      select_country1: "",
      select_province: 0,
      provinceItems: [],
      select_district: 0,
      districtItems: [],
      select_subdistrict: 0,
      subdistrictItems: [],
      countryItems: [],
      current_tel: "",
      current_tel_home: "",
      current_add: "",
      current_village: "",
      current_moo: "",
      current_lane: "",
      current_road: "",
      current_zipcode: "",
      current_building: "",
      current_province: "",
      current_province_name: "",
      current_district: "",
      current_district_name: "",
      current_subdistrict: "",
      current_subdistrict_name: "",
      current_name: "",
      current_surname: "",
      current_country: "",
      current_country_name: "",
      current_fax: "",
      current_email: "",
      current_authorized: "",
      current_fb: "",
      current_year: "",
    };
  },
  components: {
    vSelect
  }, computed: {
    validation_no() {
      if (this.current_add != null) {
        return this.current_add.length >= 2 && this.current_add.length < 50
      } else {
        return false;
      }
    },

    validation_village() {
      if (this.current_village != null) {
        return this.current_village.length >= 1 && this.current_village.length < 50
      } else {
        return false;
      }
    }, validation_build() {
      if (this.current_building != null) {
        return this.current_building.length >= 1 && this.current_building.length < 50
      } else {
        return false;
      }
    },
    validation_road() {
      if (this.current_road != null) {
        return this.current_road.length >= 1 && this.current_road.length < 50
      } else {
        return false;
      }
    },
    validation_soi() {
      if (this.current_lane != null) {
        return this.current_lane.length >= 1 && this.current_lane.length < 50
      } else {
        return false;
      }
    },
    validation_moo() {
      if (this.current_moo != null) {
        return this.current_moo.length >= 1 && this.current_moo.length < 50
      } else {
        return false;
      }
    },
    validation_add() {
      if (this.current_address != null) {
        return this.current_address.length >= 10 && this.current_address.length < 500
      } else {
        return false;
      }
    }

  },
  methods: {

    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      // console.log("validEmail==",email,re.test(email));
      return re.test(email);
    },
    validPhone() {
      // var phoneno = /^\(?([0-9]{2})\)?[-]?([0-9]{4})[-]?([0-9]{4})$/; // /^\d{10}$/;  // /^[0-9]\d{2}-\d{3}-\d{4}$/;
      var phoneno10 = /^\d{10}$/;
      var phoneno11 = /^\d{11}$/;
      var phoneno12 = /^\d{12}$/;
      var phoneno13 = /^\d{13}$/;
      var phoneno14 = /^\d{14}$/;
      var phoneno15 = /^\d{15}$/;
      var phoneno16 = /^\d{16}$/;
      var phoneno17 = /^\d{17}$/;
      var phoneno18 = /^\d{18}$/;
      var phoneno19 = /^\d{19}$/;
      var phoneno20 = /^\d{20}$/;
      var phoneno21 = /^\d{21}$/;
      var phoneno22 = /^\d{22}$/;
      var phoneno23 = /^\d{23}$/;
      var phoneno24 = /^\d{24}$/;
      var phoneno25 = /^\d{25}$/;
      var phoneno26 = /^\d{26}$/;
      var phoneno27 = /^\d{27}$/;
      var phoneno28 = /^\d{28}$/;
      var phoneno29 = /^\d{29}$/;
      var phoneno30 = /^\d{30}$/;
      if (this.current_tel.match(phoneno10) || this.current_tel.match(phoneno11) || this.current_tel.match(phoneno12) || this.current_tel.match(phoneno14)
        || this.current_tel.match(phoneno15) || this.current_tel.match(phoneno16) || this.current_tel.match(phoneno17) || this.current_tel.match(phoneno18)
        || this.current_tel.match(phoneno19) || this.current_tel.match(phoneno20) || this.current_tel.match(phoneno21) || this.current_tel.match(phoneno22)
        || this.current_tel.match(phoneno23) || this.current_tel.match(phoneno24) || this.current_tel.match(phoneno25) || this.current_tel.match(phoneno26)
        || this.current_tel.match(phoneno27) || this.current_tel.match(phoneno28) || this.current_tel.match(phoneno29) || this.current_tel.match(phoneno30)) {
        // console.log("--------true---------",this.current_tel);
        return true;
      } else {
        // console.log("--------false---------",this.current_tel);
        return false;
      }
    },
    getCountry(thaistudent) {
      api
        .getCountryNoThaiPost(thaistudent)
        .then(res => {
          this.countryItems = res.data.data;
          // console.log("res==", res);
        })
        .catch(err => {
          console.log("getCountry", err.toString());
        });
    },
    selectCountryOnchange: function () {
      this.select_country = this.select_country1.COUNTRYID;
      // console.log("select_country==", this.select_country);
      this.current_country_name = this.select_country1.COUNTRYNAME;
      //  api
      //   .getCountryById(this.select_country,this.student.thaistudent)
      //   .then(res => {
      //     this.current_country_name = res.data.data[0].COUNTRYNAME;
      //   })
      //   .catch(err => {
      //     // console.log(2);
      //     console.log("getCountryById", err.toString());
      //   });
    },
    getProvinceAll(thaistudent) {
      api
        .getProvinceAll(thaistudent)
        .then(res => {
          this.provinceItems = res.data.data;
        })
        .catch(err => {

          console.log("getProvince", err.toString());
        });
    },
    getProvinceId(thaistudent) {
      api
        .getProvinceById(thaistudent)
        .then(res => {
          this.current_province_name = res.data.data[0].PROVINCENAME;
          // console.log("current_province_name", this.current_province_name);
        })
        .catch(err => {

          console.log("getProvince", err.toString());
        });
    },
    getDistrictId(id, thaistudent) {
      api
        .getDistrictByDistrictid(id, thaistudent)
        .then(res => {
          this.current_district_name = res.data.data[0].DISTRICTNAME;
          // console.log("current_district_name", this.current_district_name);
        })
        .catch(err => {

          console.log("getProvince", err.toString());
        });
    },
    getSubDistrictId(id, thaistudent) {
      // console.log("id==",id)
      api
        .getSubDistrictBySubdistricid(id, thaistudent)
        .then(res => {
          this.current_subdistrict_name = res.data.data[0].SUB_DISTRICTNAME;
          // console.log("current_subdistrict_name", this.current_subdistrict_name);
        })
        .catch(err => {

          console.log("getProvince", err.toString());
        });
    },
    onloadDistrictById: async function () {
      api
        .getDistrictByid(this.select_province, this.student.thaistudent)
        .then(res => {
          this.districtItems = res.data.data;
        })
        .catch(err => {
          console.log("onloadDistrictById", err.toString());
        });
    },
    onloadSubDistrictById: async function () {
      api
        .getSubDistrictByid(this.select_district, this.student.thaistudent)
        .then(res => {
          this.subdistrictItems = res.data.data;
        })
        .catch(err => {
          console.log("onloadSubDistrictById", err.toString());
        });
    },
    onloadZipcodeById: async function () {
      api
        .getZipcode(this.select_subdistrict, this.student.thaistudent)
        .then(res => {
          this.current_subdistrict = this.select_subdistrict;
          this.current_zipcode = res.data.data[0].ZIPCODE;
        })
        .catch(err => {
          console.log("onloadZipcodeById", err.toString());
        });
    },
    selectProvinceOnchange: function () {
      this.onloadDistrictById(this.select_province);
      this.getProvinceId(this.select_province);
      console.log("select_province981== ", this.select_province);
      this.select_subdistrict = 0;
    },
    selectDistrictOnchange: function () {
      this.current_district = this.select_district;
      console.log("894== ", this.select_district);
      this.getDistrictId(this.select_district);
      this.onloadSubDistrictById(this.select_district);
    },
    selectSubDistrictOnchange: function () {
      this.getSubDistrictId(this.select_subdistrict);
      this.onloadZipcodeById(this.select_subdistrict);
    },
    getStudentGeneral(studentid) {
      api
        .getStudentGeneral_63(studentid)
        .then(res => {
          if (res.data.data.length > 0) {
            // console.log("getStudentGeneral res== ",res);
            var currentSt = res.data.data[0];
            this.current_name = currentSt.STUDENTNAME;
            this.current_surname = currentSt.STUDENTSURNAME;
            this.current_tel = currentSt.CURRENT_TEL;
            this.current_country = currentSt.CURRENT_COUNTRY;
            this.current_email = currentSt.CURRENT_EMAIL;
            this.current_add = currentSt.CURRENT_NO;
            this.current_village = currentSt.CURRENT_VILLAGE;
            this.current_building = currentSt.CURRENT_BUILDING;
            this.current_moo = currentSt.CURRENT_MOO;
            this.current_lane = currentSt.CURRENT_LANE;
            this.current_road = currentSt.CURRENT_ROAD;
            this.current_zipcode = currentSt.CURRENT_ZIPCODE;
            this.select_provinceid = currentSt.CURRENT_PROVINCEID;
            //this.select_district = currentSt.CURRENT_DISTRICT; เอาออกก่อน เดี๋ยวตำบลไม่ขึ้น
            this.current_subdistrict = currentSt.CURRENT_SUBDISTRICT;
            this.current_country = currentSt.CURRENT_COUNTRY;
            if ((this.selected_post == 21) || (this.selected_post == 22)) {
              // console.log("selected_post== ",this.selected_post);
              this.getProvinceAll(this.student.thaistudent);
              this.select_province = currentSt.CURRENT_PROVINCEID;
              // console.log("select_province== ",currentSt.CURRENT_PROVINCEID);
              this.select_district = currentSt.CURRENT_DISTRICT;
              this.onloadDistrictById(this.select_province);
              this.select_subdistrict = currentSt.CURRENT_SUBDISTRICT;
              this.onloadSubDistrictById(this.select_district);
            }
            if ((this.current_province_name != '') && (this.current_province_name != 0) && (this.current_province_name != null) && (this.current_province_name != undefined)) {
              this.getProvinceId(this.select_province, this.student.thaistudent);
            }
            if ((this.current_district_name != '') && (this.current_district_name != 0) && (this.current_district_name != null) && (this.current_district_name != undefined)) {
              // console.log("942== ",this.select_district);
              this.getDistrictId(this.select_district, this.student.thaistudent);
            }
            if ((this.current_subdistrict_name != '') && (this.current_subdistrict_name != 0) && (this.current_subdistrict_name != null) && (this.current_subdistrict_name != undefined)) {
              this.getSubDistrictId(this.select_subdistrict, this.student.thaistudent);
            }

            this.getCountry(this.student.thaistudent);
            this.select_country = currentSt.CURRENT_COUNTRY;
            // this.student.current_country_name=currentSt.CURRENT_COUNTRY_NAME;
            this.current_country_name = currentSt.CURRENT_COUNTRY_NAME;

            // }

          } else {
          }
        })
        .catch(err => {
          this.actionUpdate = false;
          console.log("getStudentGeneral", err.toString());
          this.$router.push("/Login_63");
        });
      return this.actionUpdate;
    },
    getCurrentStudent(student) {
      api
        .getStudentPostById_80(student)
        .then(res => {
          // console.log(" student==",student);
          // console.log(" getCurrentStudent==",res.data.data[0]);
          var currentSt = res.data.data[0];
          if (res.data.data.length > 0) {
            if (res.data.data[0].POST_STATUS == null) {
              this.actionUpdate = false;
              // console.log("964 getCurrentStudent ไม่มี",this.actionUpdate,res);
            } else {
              this.actionUpdate = true;
              // console.log(" getCurrentStudent มีข้อมูล",this.actionUpdate,res);
            }
            // console.log("xxx==",this.actionUpdate);
            this.selected_post = res.data.data[0].POST_STATUS;
            // console.log(" this.selected_post ",this.selected_post );

            if ((this.selected_post == 11) || (this.selected_post == null)) {
              this.getStudentGeneral(this.student.studentid);
            }
            if (this.selected_post == 12) {
              this.current_authorized = res.data.data[0].POST_AUTHORIZED_PERSON;
              this.getStudentGeneral(this.student.studentid);
            }
            if ((this.selected_post == 21) || (this.selected_post == 22)) {

              this.current_name = res.data.data[0].POST_FIRST_NAME;
              this.current_surname = res.data.data[0].POST_LAST_NAME;
              this.current_add = res.data.data[0].POST_ADD;
              this.getProvinceAll(this.thai_student);
              this.select_province = res.data.data[0].POST_PROVICE;
              // console.log(" select_province==",res.data.data[0].POST_PROVICE);
              this.current_province_name = res.data.data[0].POST_PROVICE_NAME;
              this.onloadDistrictById(this.select_province);
              this.select_district = res.data.data[0].POST_DISTRICT;
              // console.log(" select_district1094==",this.select_district);
              this.current_district_name = res.data.data[0].POST_DISTRICT_NAME;
              this.select_subdistrict = res.data.data[0].POST_TAMBON;
              // console.log("xx==", this.select_district)
              if (this.select_district != '')
                this.onloadSubDistrictById(this.select_district);
              this.current_subdistrict_name = res.data.data[0].POST_TAMBON_NAME;
              this.current_zipcode = res.data.data[0].POST_ZIPCODE;
              this.current_moo = res.data.data[0].POST_MOO;
              this.current_village = res.data.data[0].POST_BAN;
              this.current_building = res.data.data[0].POST_BUILDING;
              this.current_lane = res.data.data[0].POST_SOI;
              this.current_road = res.data.data[0].POST_STREET;
              this.current_tel = res.data.data[0].POST_TEL;
              this.current_tel_home = res.data.data[0].POST_TEL_HOME;
              this.current_fax = res.data.data[0].POST_FAX;
              this.current_email = res.data.data[0].POST_EMAIL;
              this.current_fb = res.data.data[0].POST_FACEBOOK;
            }
            if (this.selected_post == 31) {

              this.current_name = res.data.data[0].POST_FIRST_NAME;
              this.current_surname = res.data.data[0].POST_LAST_NAME;
              this.select_country = res.data.data[0].POST_COUNTRY;
              this.select_country1 = res.data.data[0].POST_COUNTRY_NAME;
              this.current_country_name = res.data.data[0].POST_COUNTRY_NAME;
              // console.log("current_country_name== ",this.current_country_name);
              this.current_add = res.data.data[0].POST_ADD;
              this.current_tel = res.data.data[0].POST_TEL;
              this.current_tel_home = res.data.data[0].POST_TEL_HOME;
              this.current_fax = res.data.data[0].POST_FAX;
              this.current_email = res.data.data[0].POST_EMAIL;
              this.current_fb = res.data.data[0].POST_FACEBOOK;
            }


          } else {
            this.actionUpdate = false;
            console.log(" getCurrentStudent ไม่มีข้อมูล", this.actionUpdate);
            this.getStudentGeneral(this.std_id);
            // this.$router.push("/Login_63");
            // if (this.selected_post==21 || this.selected_post==22){
            //   console.log("selected_post==",this.selected_post);
            //   this.getStudentGeneral(this.std_id);
            // }
          }
        })
        .catch(err => {
          console.log("getCurrentStudent 1139", err.toString());
          this.actionUpdate = false;
          // this.$router.push("/Login_63");

        });
    },

    setStudent: function () {
      var studentpost = {};
      studentpost.std_id = this.$store.state.user.studentid;
      studentpost.studentid = this.$store.state.user.studentid;
      studentpost.current_year = 2563;
      studentpost.year = 2563;
      studentpost.thai_student = this.$store.state.user.thaistudent
      studentpost.levelid = this.$store.state.user.levelid;
      studentpost.selected_post = this.selected_post;

      studentpost.current_authorized = "";
      studentpost.current_name = "";
      studentpost.current_surname = "";
      studentpost.current_country = "";
      studentpost.current_country_name = "";
      studentpost.current_add = "";
      studentpost.current_province = "";
      studentpost.current_province_name = "";

      studentpost.current_district = "";
      studentpost.current_district_name = "";
      studentpost.current_subdistrict = "";
      studentpost.current_subdistrict_name = "";
      studentpost.current_zipcode = "";
      studentpost.current_moo = "";
      studentpost.current_village = "";
      studentpost.current_building = "";
      studentpost.current_lane = "";
      studentpost.current_road = "";
      studentpost.current_tel = "";
      studentpost.current_tel_home = "";
      studentpost.current_fax = "";
      studentpost.current_email = "";
      studentpost.current_fb = "";

      if (this.selected_post == 11 || this.selected_post == 12) {
        if (this.selected_post == 12) {
          studentpost.current_authorized = this.current_authorized;
        }
        studentpost.current_tel = this.current_tel;
        studentpost.current_tel_home = this.current_tel_home;
        studentpost.current_fax = this.current_fax;
        studentpost.current_email = this.current_email;
        studentpost.current_fb = this.current_fb;
      }
      if ((this.selected_post == 21) || (this.selected_post == 22)) {

        studentpost.current_name = this.current_name;
        studentpost.current_surname = this.current_surname;
        studentpost.current_country = "41";
        if (this.student.thaistudent == 1) {
          studentpost.current_country_name = "ไทย";
        } else {
          studentpost.current_country_name = "Thailand";
        }
        studentpost.current_add = this.current_add;
        studentpost.current_province = this.select_province;
        // console.log("current_province_name== ", this.current_province_name);
        studentpost.current_province = this.select_province;
        studentpost.current_province_name = this.current_province_name;
        studentpost.current_district = this.select_district;
        studentpost.current_district_name = this.current_district_name;
        studentpost.current_subdistrict = this.select_subdistrict;
        studentpost.current_subdistrict_name = this.current_subdistrict_name;
        studentpost.current_zipcode = this.current_zipcode;
        studentpost.current_moo = this.current_moo;
        studentpost.current_village = this.current_village;
        studentpost.current_building = this.current_building;
        studentpost.current_lane = this.current_lane;
        studentpost.current_road = this.current_road;
        studentpost.current_tel = this.current_tel;
        studentpost.current_tel_home = this.current_tel_home;
        studentpost.current_fax = this.current_fax;
        studentpost.current_email = this.current_email;
        studentpost.current_fb = this.current_fb;
      }
      if (this.selected_post == 31) {
        studentpost.current_name = this.current_name;
        studentpost.current_surname = this.current_surname;
        studentpost.current_country = this.select_country;
        studentpost.current_country_name = this.current_country_name;
        studentpost.current_add = this.current_add;
        studentpost.current_tel = this.current_tel;
        studentpost.current_tel_home = this.current_tel_home;
        studentpost.current_fax = this.current_fax;
        studentpost.current_email = this.current_email;
        studentpost.current_fb = this.current_fb;

      }
      return studentpost;
    },
    getErrorTxt() {
      this.current_erorrtxt = "";
      this.numEror = 0;
      // console.log("selected_post== ",this.selected_post);
      if (this.selected_post == null || this.selected_post == undefined|| this.selected_post == 0 || this.selected_post == ''){
        this.numEror = this.numEror + 1;
        this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/ยืนยันการติดต่อขอรับปริญญาบัตร " : this.current_erorrtxt + "/The way to obtain Certificate";
      }
      if (this.selected_post == 12) {

        if ((this.current_authorized == '') || (this.current_authorized == null)) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/ระบุชื่อ-นามสกุลผู้รับมอบฉันทะ " : this.current_erorrtxt + "/Please specify";
        }
      }
      if ((this.selected_post == 21) || (this.selected_post == 22)) {
        if ((this.current_name == "None") || (this.current_name == null) || (this.current_name == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/ชื่อ" : this.current_erorrtxt + "/Name";
        }
        if ((this.current_surname == "None") || (this.current_surname == null) || (this.current_surname == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/นามสกุล" : this.current_erorrtxt + "/Surname";
        }


        if ((this.select_province == 0) || (this.select_province == null) || (this.select_province == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/จังหวัด" : this.current_erorrtxt + "/Select province";
        }
        if ((this.select_district == 0) || (this.select_district == null) || (this.select_district == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/อำเภอ" : this.current_erorrtxt + "/Select district";
        }
        if ((this.select_subdistrict == 0) || (this.select_subdistrict == null) || (this.select_subdistrict == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/ตำบล" : this.current_erorrtxt + "/Select Subdistrict";
        }
        if ((this.current_add == 0) || (this.current_add == null) || (this.current_add == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/บ้านเลขที่" : this.current_erorrtxt + "/Address number";
        }
        if ((this.current_moo == 0) || (this.current_moo == null) || (this.current_moo == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/หมู่" : this.current_erorrtxt + "/Moo";
        }
        if ((this.current_village == 0) || (this.current_village == null) || (this.current_village == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/หมู่บ้าน" : this.current_erorrtxt + "/Village";
        }
        if ((this.current_building == 0) || (this.current_building == null) || (this.current_building == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/อาคาร" : this.current_erorrtxt + "/Building";
        }
        if ((this.current_lane == 0) || (this.current_lane == null) || (this.current_lane == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/ซอย" : this.current_erorrtxt + "/Soi";
        }
        if ((this.current_road == 0) || (this.current_road == null) || (this.current_road == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/ถนน" : this.current_erorrtxt + "/Road";
        }
        if ((this.current_tel == 0) || (this.current_tel == null) || (this.current_tel == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/โทรศัพท์มือถือ" : this.current_erorrtxt + "/Mobile";
        }
        if (this.student.thaistudent == "1") {
        if (!this.validPhone()) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/โทรศัพท์ ตัวเลขเท่านั้น" : this.current_erorrtxt + "/Phone Number:";
        }
        if ((this.current_tel_home == 0) || (this.current_tel_home == null) || (this.current_tel_home == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/โทรศัพท์บ้าน" : this.current_erorrtxt + "/Home Phone";
        }
        if ((this.current_fax == 0) || (this.current_fax == null) || (this.current_fax == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/Fax" : this.current_erorrtxt + "/Fax";
        }}
        if ((this.current_email == 0) || (this.current_email == null) || (this.current_email == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/E-mail" : this.current_erorrtxt + "/E-mail";
        }
        if (!this.validEmail(this.current_email)) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/ตรวจสอบอีเมล์" : this.current_erorrtxt + "/Valid email required";
        }
        if ((this.current_fb == 0) || (this.current_fb == null) || (this.current_fb == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/Facebook" : this.current_erorrtxt + "/Facebook";
        }

      }
      if ((this.selected_post == 31)) {
        // console.log("this.select_country",this.select_country);
        if ((this.select_country == "None") || (this.select_country == null) || (this.select_country == '') || (this.select_country == 0) || (this.select_country == 41)) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/ประเทศ" : this.current_erorrtxt + "/Country";
        }

        if ((this.current_name == "None") || (this.current_name == null) || (this.current_name == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/ชื่อ" : this.current_erorrtxt + "/Name";
        }
        if ((this.current_surname == "None") || (this.current_surname == null) || (this.current_surname == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/นามสกุล" : this.current_erorrtxt + "/Surname";
        }
        if ((this.current_add == 0) || (this.current_add == null) || (this.current_add == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/ที่อยู่" : this.current_erorrtxt + "/Address";
        }
       /* if (!this.validPhone()) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/โทรศัพท์ ตัวเลขเท่านั้น " : this.current_erorrtxt + "/Phone Number:";
        }*/
        if ((this.current_tel == 0) || (this.current_tel == null) || (this.current_tel == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/โทรศัพท์มือถือ" : this.current_erorrtxt + "/Mobile";
        }
        if ((this.current_tel_home == 0) || (this.current_tel_home == null) || (this.current_tel_home == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/โทรศัพท์บ้าน" : this.current_erorrtxt + "/Home Phone";
        }
        if ((this.current_fax == 0) || (this.current_fax == null) || (this.current_fax == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/Fax" : this.current_erorrtxt + "/Fax";
        }
        if (!this.validEmail(this.current_email)) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/ตรวจสอบอีเมล์" : this.current_erorrtxt + "/Valid email required";
        }
        if ((this.current_email == 0) || (this.current_email == null) || (this.current_email == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/E-mail" : this.current_erorrtxt + "/E-mail";
        }
        if ((this.current_fb == 0) || (this.current_fb == null) || (this.current_fb == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/Facebook" : this.current_erorrtxt + "/Facebook";
        }
      }


      if (this.numEror == 0) {
        this.dangerModal = false;
      } else {
        this.dangerModal = true;
      }
      return this.numEror;
    },
    onSubmit() {
      var student_post = {};
      student_post = this.setStudent();
      // console.log("student save=", student_post);
      this.numEror = this.getErrorTxt();
      // console.log("numEror save=", this.numEror);
      if (this.numEror == 0) {
        if (this.actionUpdate == false) {
          // save
          // console.log("967student save=", student_post);
          this.onCreateData(student_post);
        } else {
          // update
          this.onUpdateData(student_post);
        }
      }

    },
    nextPart() {
      if (this.selected_post == 11) { //ด้วยตนเอง
        this.$router.push("Person");
      } else if (this.selected_post == 12) { //มอบฉันทะ
        this.$router.push("\Authorized");
      } else if (this.selected_post == 21) {
        this.$router.push("\Regispost");
      } else if (this.selected_post == 22) {
        this.$router.push("\Regispost");
      } else if (this.selected_post == 31) {
        this.$router.push("Person");
      }
    },
    onCreateData(student) {
      // console.log("student==", student);
      api
        .postStudentPost(student)
        .then(res => {
          // console.log("res==", res);
          this.message = res.message;
          // console.log("insert ผ่าน");
          this.nextPart();
        })
        .catch(err => {
          console.log("onCreateData", err.toString());
          // this.$router.push("/Login_63");
        });
    },
    onUpdateData(student) {
      api
        .updateStudentPost(student)
        .then(res => {
          // console.log(res);
          this.message = res.message;
          // console.log("update ผ่าน");
          this.nextPart();
        })
        .catch(err => {
          console.log("onUpdateData error", err.toString());
          // this.$router.push("/Login_63");
        })
    },
    getPosttype(columname, thaistudent, start, finish) {
      api
        .getPostTypeBetween(columname, thaistudent, start, finish)
        .then(res => {
          // console.log("res==",res);
          if (start == 11) {
            this.items = res.data.data;

          } else if (start == 21) {
            this.items1 = res.data.data;
          } else if (start == 31) {
            this.items2 = res.data.data;
          }
          // console.log("res==",res);


        })
        .catch(err => {

          console.log("getPosttype", err.toString());
        });
    },
  },
  mounted() {
  },
  created() {
    if (this.$store.state.token == null || this.$store.state.user == null) {
      this.$router.push("/Login_63");
    } else {
      // this.$router.push("/Dashboard");
    }
    this.student.studentid = this.$store.state.user.studentid;
    this.student.thaistudent = this.$store.state.user.thaistudent;
    this.thai_student= this.$store.state.user.thaistudent;
    this.student.levelid = this.$store.state.user.levelid;
    this.student.year = 2563;
    // console.log("student==",student)
    this.actionUpdate = this.getCurrentStudent(this.student);
    this.getPosttype('POST_STATUS', this.student.thaistudent, 11, 12);
    this.getPosttype('POST_STATUS', this.student.thaistudent, 21, 22);
    this.getPosttype('POST_STATUS', this.student.thaistudent, 31, 31);
    this.getCountry(this.student.thaistudent);

    this.getProvinceAll(this.student.thaistudent);

  }
};
</script>
<style>
</style>
